import React, { Component } from "react";
import { NotificationManager } from "react-notifications";

import {
    Col,
    Row,
    Table
} from "reactstrap";

import TYPagination from "../TYPagination";
import Registry from "../../Utils/Registry";
import Helpers from "../../Utils/Helpers";

const days = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];



export default class OperationsRecurrentList extends Component{
    constructor(props){
        super(props);

        this.state = {
            list: [],
            loading: false,
            per_page: 8,
            page: 1,
            total_pages: 1,
        };

        this.api = Registry.registered("api");
    }

    componentDidMount(){
        this.loadList();
    }

    loadList = () => {
        this.setState({loading: true, list: []});
        const { per_page, page } = this.state;
        let route = `/recurrent?per_page=${per_page}&page=${page}&is_active=1`;
        this.api.get(route)
            .then(r => this.setState({
                loading: false,
                list: r.results,
                per_page: r.per_page,
                page: r.page,
                total_pages: r.total_pages
            }))
            .catch(_ => {
                this.setState({loading: false});
                NotificationManager.error("Impossible de charger la liste des recurrences");
            });
    }

    changePage = page => this.setState({page: page}, this.loadList);

    render(){
        return <Row>
            <Col xs="12" sm="12" lg="8">
                {
                    this.state.loading ?
                        <div className="center">
                            <i className="icon icon-loading animated spin infinite f-20"> </i>
                        </div>
                        :
                        <div>
                            <div className="d-flex justify-content-between marg-b-15">
                                <h2 className="ty-subtitle align-self-center">Vos commandes r&eacute;currentes</h2>
                                <TYPagination
                                    page={this.state.page}
                                    total_pages={this.state.total_pages}
                                    onPageChanged={this.changePage}
                                />
                            </div>
                            
                            <div className="ty-block">
                                <Table responsive striped hover className="pointer spacing-table marg-b-0 f-12">
                                    <thead>
                                        <tr className="ty-table-header">
                                            <th className="wp-25">Jours</th>
                                            <th className="wp-25">Heure</th>
                                            <th className="">Adresse</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.list.map((l, i) => {
                                                return <tr key={"rec-l+" + i} onClick={() => { Helpers.goTo("/recurrence/" + l.id); }}>
                                                    <td className="wp-25">{ l.weekdays_repeat.split(",").map(i => days[i]).join(", ") }</td>
                                                    <td className="wp-25">{ l.recurrent_hour }</td>
                                                    <td>{ l.location }</td>
                                                </tr>
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                }
            </Col>
        </Row>
    }
}


// WEBPACK FOOTER //
// ./src/components/Operations/Recurrents.js